var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.456V9.5625C16 10.1851 15.746 10.7841 15.2899 11.2367C14.8338 11.6892 14.2102 11.961 13.5472 11.9963L13.4 12H2.6C1.93589 12 1.29694 11.7618 0.814215 11.3342C0.331493 10.9067 0.0415989 10.3221 0.00400009 9.7005L0 9.5625V3.456L7.7216 7.248C7.8075 7.29018 7.90303 7.31222 8 7.31222C8.09697 7.31222 8.1925 7.29018 8.2784 7.248L16 3.456ZM2.6 1.77038e-08H13.4C14.0445 -7.2761e-05 14.666 0.224247 15.144 0.62945C15.6221 1.03465 15.9226 1.59186 15.9872 2.193L8 6.1155L0.0128 2.193C0.0748187 1.61573 0.35444 1.07814 0.8014 0.676847C1.24836 0.275557 1.83335 0.0368902 2.4512 0.0037501L2.6 1.77038e-08H13.4H2.6Z",
    fill: "#2D2D2D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.84900e857cb994bed182b3cd2ca3a645.svg";
export { ForwardRef as ReactComponent };